import React from "react";
import { Redirect, useParams } from "react-router-dom";

const EditUser = () => {
  const { id } = useParams();
  return <Redirect to={`/dashboard/utenti?edit=${id}`} />;
};

export default EditUser;
